<template>
  <div>
    <div class="xls-csv-parser">
      <span v-if="filename"
        >Dosya adı: {{ filename }}, maximum 1000 adetli liste yükleyiniz.</span
      >
      <parse-file
        @fileDataReceived="fileDataReceived"
        @fileNameReceived="fileNameReceived"
        :help="help"
        ref="parseFile"
        :lang="lang"
      ></parse-file> 
      <column-chooser
        v-if="showColumnChooser"
        ref="columnChooser"
        :userColumns="userColumns"
        :columns="columns"
        :showValidateButton="showValidateButton"
        :lang="lang"
        @on-validate="onValidate"
      ></column-chooser>
      <div class="parser-hidden-columns-input" v-for="(result, i) in results">
        <input
          type="hidden"
          v-for="(data, i) in result.data"
          :name="`${result.column}[${i}]`"
          :value="data"
        />
      </div>
      <simplert :useRadius="true" :useIcon="true" ref="simplert"></simplert>
    </div>
  </div>
</template>

<script>
import _ from "lodash";
import Simplert from "vue2-simplert";
import ColumnChooser from "./ColumnChooser";
import ParseFile from "./ParseFile";
import text from "../lang";
import EventBus from "../../../Ui/EventBus";

export default {
  name: "XlsCsvParser",
  components: { ColumnChooser, ParseFile, Simplert },
  props: {
    columns: {
      type: Array,
      required: true,
      validator: (columns) =>
        columns.every(
          (column) => _.has(column, "name") && _.has(column, "value")
        ),
    },
    validateButtonId: {
      type: String,
      default: () => null,
    },
    help: {
      type: String,
    },
    lang: {
      type: String,
      validator: (language) => ["en", "fr"].indexOf(language) !== -1,
      default: () => "en",
    },
  },
  methods: {
    makeid(length) {
      var result = "";
      var characters =
        "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789";
      var charactersLength = characters.length;
      for (var i = 0; i < length; i++) {
        result += characters.charAt(
          Math.floor(Math.random() * charactersLength)
        );
      }
      return result;
    },
    sanitizeForPusherChannel(input, maxLength = 164) {
      // Tüm boşlukları kaldır
      input = input.replace(/\s+/g, "");

      // Geçersiz karakterleri kaldır (sadece alfanumerik karakterler, alt çizgi ve tire kalacak)
      input = input.replace(/[^a-zA-Z0-9_\-]/g, "");

      // Maksimum karakter sınırını kontrol et
      if (input.length > maxLength) {
        input = input.substring(0, maxLength);
      }

      return input;
    },

    fileNameReceived(name) {
      this.filename = name;
      let excelId = this.sanitizeForPusherChannel(name + "_" + this.makeid(11));

      localStorage.setItem("excelUploadId", excelId);
      EventBus.$emit("excelUploadId", excelId);
    },
    fileDataReceived(fileData) {
      this.results = [];
      const requiredColumns = this.columns.filter(
        (column) => !column.isOptional
      );
      if (fileData.length < requiredColumns.length) {
        const message = `${
          text[this.lang].error.columnNumber
        }<br> ${this.columns.map((column) => column.name).join("<br> ")}`;
        this.showError(message);
        return;
      }
      this.userColumns = fileData;
      this.showColumnChooser = true;
    },
    onValidate(results) {
      this.results = results;
      this.$emit("on-validate", results);
    },
    validate(event) {
      event.preventDefault();
      if (!this.showColumnChooser) {
        this.showError(text[this.lang].error.fileNumber);
      } else {
        this.$refs.columnChooser.validate();
      }
    },
    showError(message) {
      this.$refs.simplert.openSimplert({
        title: text[this.lang].error.title,
        message,
        type: "error",
        customCloseBtnText: text[this.lang].close,
        onClose: () => {
          this.$refs.parseFile.reset();
        },
      });
    },
  },
  mounted() {
    if (this.validateButtonId) {
      this.showValidateButton = false;
      document
        .getElementById(this.validateButtonId)
        .addEventListener("click", this.validate);
    }
  },
  data() {
    return {
      showColumnChooser: false,
      showHiddenInputs: false,
      showValidateButton: true,
      results: [],
      userColumns: [],
    };
  },
};
</script>
